import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: '首页', href: '/' },
  { label: '产品', href: '/products' },
  { label: '赛事', href: '/arena' },
  { label: '商城', href: '/shop' },
  { label: '模型库', href: '/models' },
  { label: '排行榜', href: '/rankings' },
  { label: '课程', href: '/education' },
  { label: '活动', href: '/events' },
  { label: '资源', href: '/resources' },
  { label: '关于', href: '/about' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <nav className="nav-armor h-20 bg-black">
      <div className="h-full max-w-[1300px] mx-auto px-8 flex items-center">
        {/* Left: Logo */}
        <Link to="/" className="flex items-center gap-2.5 shrink-0">
          <img
            src="/images/logo-full.webp"
            alt="LOGO"
            className="h-[18px] w-auto object-contain"
          />
        </Link>

        {/* Center: Navigation links */}
        <div className="hidden lg:flex items-center flex-nowrap absolute left-1/2 -translate-x-1/2">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-3 py-2 text-sm font-bold tracking-wide whitespace-nowrap transition-colors ${
                pathname === link.href
                  ? 'text-arena-blue'
                  : 'text-white/95 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Right: CTA buttons */}
        <div className="hidden lg:flex items-center gap-3 shrink-0 ml-auto">
          <Link to="/login" className="text-sm font-bold text-white/95 hover:text-white px-2 py-1.5 transition-colors">登录</Link>
          <Link to="/register" className="text-sm font-bold bg-arena-blue text-white px-5 py-1.5 rounded-sm hover:brightness-110 transition-all">立即加入</Link>
        </div>

        {/* Mobile hamburger */}
        <button className="lg:hidden p-2 text-white/70" onClick={() => setMobileOpen(!mobileOpen)}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {mobileOpen ? <path d="M18 6L6 18M6 6l12 12" /> : <path d="M3 12h18M3 6h18M3 18h18" />}
          </svg>
        </button>
      </div>

      {/* Mobile dropdown */}
      {mobileOpen && (
        <>
          {/* Backdrop overlay */}
          <div className="lg:hidden fixed inset-0 top-20 bg-black/80 z-40" onClick={() => setMobileOpen(false)} />
          {/* Menu */}
          <div className="lg:hidden bg-black border-b border-border-dark px-6 py-4 flex flex-col gap-1 relative z-50">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setMobileOpen(false)}
                className={`px-3 py-2 rounded text-base font-bold ${pathname === link.href ? 'text-arena-blue bg-arena-blue/10' : 'text-white/95 hover:text-white'}`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-2 pt-2 mt-2 border-t border-border-dark">
              <Link to="/login" className="flex-1 text-center text-sm text-white/90 py-2" onClick={() => setMobileOpen(false)}>登录</Link>
              <Link to="/register" className="flex-1 text-center text-sm bg-arena-blue text-white py-2 rounded-sm font-medium" onClick={() => setMobileOpen(false)}>立即加入</Link>
            </div>
          </div>
        </>
      )}
    </nav>
  );
}
